import { useEffect } from 'react';

function themeMeta(): HTMLMetaElement | null {
  return document.querySelector('meta[name="theme-color"]');
}

export function useThemeColor(color: string, wideColor: string = color): void {
  useEffect(() => {
    const meta = themeMeta();
    if (!meta) {
      return;
    }
    const previous = meta.content;
    const wide = window.matchMedia('(min-width: 64rem)');
    const apply = () => {
      meta.content = wide.matches ? wideColor : color;
    };
    apply();
    wide.addEventListener('change', apply);
    return () => {
      wide.removeEventListener('change', apply);
      meta.content = previous;
    };
  }, [color, wideColor]);
}
